import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import Forum from "@/pages/Forum";

export const Route = createFileRoute("/forum/")({
  head: () => pageHead({
    title: 'RV Community Forum',
    description: 'Join the Rex & Sons RVs community forum — ask questions, share trips and connect with fellow RV owners in North Carolina.',
    path: '/forum',
  }),
  component: Forum,
});